import { useEffect } from 'react';
var NOTHS_WEB_KEY = '72692d65-6a1f-493e-913d-e372b78f5c9a';
export var useSmartAppBanner = function useSmartAppBanner() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$hide = _ref.hide,
    hide = _ref$hide === void 0 ? false : _ref$hide;
  useEffect(function () {
    if (hide) {
      return;
    }
    var script = document.createElement('script');
    script.id = 'smart-banner-app';

    // Appsflyer smart banner SDK docs: https://dev.appsflyer.com/hc/docs/dl_smart_banner_v2
    script.innerHTML = "!function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src=\"https://websdk.appsflyer.com?\"+(c.length>0?\"st=\"+c.split(\",\").sort().join(\",\")+\"&\":\"\")+(i.length>0?\"af_id=\"+i:\"\"),p.parentNode.insertBefore(o,p)}(window,document,\"script\",0,\"AF\",\"banners\",{banners: {key: \"".concat(NOTHS_WEB_KEY, "\"}})\n    AF('banners', 'showBanner', { bannerContainerQuery: \"#smart-banner\", bannerZIndex: 100 })");
    document.head.appendChild(script);
    return function () {
      document.head.removeChild(script);
    };
  }, []);
};